import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as i}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as t}from"../../icon-registry.js";const p=t("japan",i`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <path
                d="M0 4.5H24V20.5H0V4.5Z"
                fill="white" />
            <path
                d="M12 16.9999C14.4853 16.9999 16.5 14.9852 16.5 12.5C16.5 10.0147 14.4853 8 12 8C9.51472 8 7.5 10.0147 7.5 12.5C7.5 14.9852 9.51472 16.9999 12 16.9999Z"
                fill="#D80027" />
        </svg>
    `),a=i`
    <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        static>
        <mask
            id="mask0_4915_40023"
            style="mask-type:alpha"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="24"
            height="25">
            <circle
                cx="12"
                cy="12.5"
                r="12"
                fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_4915_40023)">
            <g clip-path="url(#clip0_4915_40023)">
                <path
                    d="M-5.96484 0.5H30.0352V24.5003H-5.96484V0.5Z"
                    fill="white" />
                <path
                    d="M12.0352 19.25C15.7631 19.25 18.7852 16.2279 18.7852 12.5C18.7852 8.77208 15.7631 5.75 12.0352 5.75C8.30723 5.75 5.28516 8.77208 5.28516 12.5C5.28516 16.2279 8.30723 19.25 12.0352 19.25Z"
                    fill="#D80027" />
            </g>
        </g>
        <defs>
            <clipPath id="clip0_4915_40023">
                <rect
                    width="36"
                    height="24"
                    fill="white"
                    transform="translate(-5.96484 0.5)" />
            </clipPath>
        </defs>
    </svg>
`,n=t("japan_rounded",a),o=t("JPY",a);export{o as JPY,p as Japan,n as JapanRounded};
